<div class="logo">
  <h2>rheto<span style="color: #fba14c">.</span></h2>
</div>
<div class="main-container">
  <div class="container">
    <h1>{{ "main-heading" | transloco }}</h1>

    <div class="sub-title">
      <h2>{{ "main-content" | transloco }} <br /></h2>
    </div>
    <button (click)="gotoForm()">
      <h2>
        {{ "button" | transloco }}
      </h2>
    </button>
  </div>
  <div
    style="display: flex; position: relative; margin: 0 auto; opacity: 0"
    [@fade]="'1'"
  >
    <img class="lawyer-img" alt="Lawyer-image" src="/assets/main-pic.png" />
  </div>
</div>
